/*
 * Simple, generic opener/closer for the presale "Learn more" <dialog>.
 * Event-delegated on document so it works regardless of how many of these
 * dialogs are on the page (product-six-hundred, product-one-thousand, …)
 * and survives any section re-render.
 */
if (!window.pmaxPresaleModalInit) {
  window.pmaxPresaleModalInit = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-presale-modal-open]');
    if (opener) {
      document.getElementById(opener.dataset.presaleModalOpen)?.showModal?.();
      return;
    }

    const closer = event.target.closest('[data-presale-modal-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // Click on the backdrop (the <dialog> element itself, not its inner content)
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('pmax-presale-modal')) {
      event.target.close();
    }
  });
}
